import { useEffect, useState } from "react";
import { useNavigate, useLocation, useParams, Outlet, Link } from "react-router-dom";
import { Menu, ConfigProvider, Dropdown, Space, Button, message } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import api from "@/api";
import { findDeep, getSolutionDetail, format } from "@/utils";

import dataJson from "@/../public/data.json";

const prefix = "mySolutionDetail";
import { cloneDeep } from "lodash-es";
import { publicPath } from "@/utils/base";
import "./index.less";

function MySolutionDetail() {
  const { add, my_solution_detail, release, req_err } = dataJson;
  const [current, setCurrent] = useState("");
  const [dropdownItems, setDropdownItems] = useState<any[]>([]);
  const [dropdownList, setDropdownList] = useState([]);
  const [dropdownCur, setDropdownCur] = useState("");
  const [dropdownSelect, setDropdownSelect] = useState("");
  const [isAddVersion, setIsAddVersion] = useState<boolean>(true);

  const solutionDetail = useSelector((state: any) => state.solutionDetail);

  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;
  const { id } = useParams();

  const onClick = (e: any) => {
    if (current === e.key) {
      return;
    }
    setCurrent(e.key);
    if (e.key === "versionmanage") {
      if (!solutionDetail?.id && !solutionDetail?.versions[0]?.id) return;
      getSolutionDetail({ id: solutionDetail?.id, versionId: solutionDetail?.versions[0]?.id }, () => {
        navigate(`${publicPath}${e.item.props.url}/${solutionDetail?.id}/${solutionDetail?.versions[0]?.id}`);
      });
    } else {
      if (!solutionDetail?.id) return;
      getSolutionDetail({ id: solutionDetail?.id }, () => {
        navigate(`${publicPath}${e.item.props.url}/${solutionDetail?.id}`);
      });
    }
  };

  const dropdownOnClick = (e: any) => {
    setDropdownSelect(e.key);
    getSolutionDetail({ id, versionId: e.key }, () => {
      navigate(`${publicPath}/my_solution_detail/versionmanage/${id}/${e.key}`);
    });
  };

  const upgrade = async () => {
    const firstShowMode = findDeep(release.show_mode_arr, solutionDetail?.versions[0]?.showMode);
    if (solutionDetail?.versions?.length > 1 && firstShowMode.isUpgrade) {
      getSolutionDetail({ id, versionId: solutionDetail?.versions[0].id }, () => {
        navigate(`${publicPath}/my_solution_detail/versionmanage/${id}/${solutionDetail?.versions[0].id}`);
      });
    } else {
      try {
        const res: any = await api.upgradeVersionSolution({ solutionId: solutionDetail?.id });
        if (res?.code == 200) {
          getSolutionDetail({ id, versionId: res.data.id }, () => {
            navigate(`${publicPath}/my_solution_detail/versionmanage/${id}/${res.data.id}`);
          });
        } else {
          message.error(res.msg);
        }
      } catch (errorInfo: any) {
        message.error(errorInfo?.response?.data?.msg || req_err);
        return;
      }
    }
  };

  const to = (data: any) => {
    const { id, versions } = data;
    // 使用原生的 window.location.pathname，绕过闭包陷阱
    const currentPath = window.location.pathname;
    setDropdownCur(data.name);
    if (currentPath.includes("/info/")) {
      getSolutionDetail({ id }, () => {
        navigate(`${publicPath}/my_solution_detail/info/${id}`);
      });
    } else if (currentPath.includes("/versionmanage/")) {
      getSolutionDetail({ id, versionId: versions?.[0]?.id }, () => {
        navigate(`${publicPath}/my_solution_detail/versionmanage/${id}/${versions?.[0]?.id}`);
      });
    } else {
      getSolutionDetail({ id }, () => {
        navigate(`${publicPath}/my_solution_detail/info/${id}`);
      });
    }
  };

  const getDropdownlist = async () => {
    try {
      const res: any = await api.getSolutionNoPage({
        page: 1,
      });
      if (res.code === 200) {
        const dataCopy = cloneDeep(res.data);
        const list = dataCopy.map((item: any) => {
          return {
            key: item.id,
            name: item.name,
            label: <a onClick={() => to(item)}>{item.name}</a>,
          };
        });
        setDropdownList(list || []);
        const cur = dataCopy?.find((item: any) => item.id === id);
        setDropdownCur(cur?.name || "");
      } else {
        message.error(res.msg || req_err);
      }
    } catch (errorInfo: any) {
      console.error(errorInfo);
    }
  };

  useEffect(() => {
    if (solutionDetail) {
      const resData = cloneDeep(solutionDetail);
      const resShowMode = findDeep(release.show_mode_arr, resData?.currentVersionDetail?.showMode);
      // 有升级场景，在新版本页面，按钮要受到旧版本状态影响
      if (resShowMode?.isUpgrade && resData?.versions?.length > 1) {
        const oldShowMode = resData?.versions[1]?.showMode;
        resData.baseBtns = resShowMode?.btnsByOld[oldShowMode];
      } else {
        resData.baseBtns = resShowMode?.baseBtns;
      }
      setIsAddVersion(!resData.baseBtns?.includes("upgrade"));
      const newDropdownItems: any[] = solutionDetail?.versions?.map((item: any) => {
        const showModeItem = findDeep(release.show_mode_arr, item?.showMode);
        return {
          key: item.id,
          label: (
            <div className={`${prefix}-dropdownItems`}>
              <div className={`${prefix}-dropdownItems-version one-line-ellipsis`} title={item.version}>
                {item?.version ? (
                  <div className={`${prefix}-dropdownItems-version-text one-line-ellipsis`}>{item.version}</div>
                ) : (
                  <div className={`${prefix}-dropdownItems-version-text`}>{my_solution_detail.new_version}</div>
                )}
                <div className={`${prefix}-dropdownItems-version-status`}>{showModeItem.title}</div>
              </div>
              <div className={`${prefix}-dropdownItems-time`}>
                {format(new Date(Number(item.createTime)), "yy年MM月dd日 HH:mm")}
              </div>
            </div>
          ),
        };
      });
      setDropdownItems(newDropdownItems || []);
    }
  }, [solutionDetail]);

  useEffect(() => {
    if (pathname.includes("/info/")) {
      setCurrent("info");
      setDropdownSelect("");
    } else if (pathname.includes("/versionmanage/")) {
      setCurrent("versionmanage");
      const pathArr = pathname.split("/");
      const vId = pathArr[pathArr.length - 1];
      if (vId && vId !== id) {
        setDropdownSelect(vId);
      } else {
        setDropdownSelect("");
      }
    } else {
      setDropdownSelect("");
    }
  }, [pathname, id]);

  useEffect(() => {
    if (id) {
      getSolutionDetail({ id });
    }
    getDropdownlist();
  }, []);
  return (
    <div className={prefix}>
      <div className={`${prefix}-menu-wrap`}>
        <ConfigProvider
          theme={{
            components: {
              Menu: {
                itemSelectedBg: "#0A59F7",
                itemSelectedColor: "#fff",
                itemBorderRadius: 0,
                iconSize: 14,
                itemHeight: 64,
                fontSize: 18,
              },
            },
          }}
        >
          <Menu
            onClick={onClick}
            mode="inline"
            items={my_solution_detail.menu}
            defaultOpenKeys={["distribute"]}
            selectedKeys={[current]}
            className={`${prefix}-menu`}
          />
        </ConfigProvider>
      </div>
      <ConfigProvider
        theme={{
          components: {
            Button: { colorPrimary: "#0A59F7" },
            Tabs: { colorPrimary: "#0A59F7" },
          },
        }}
      >
        <div className={`${prefix}-top`}>
          <div className={`${prefix}-breadCrumb`}>
            <Link to={`${publicPath}/staging`} state={{ tabKey: "4" }} className={`${prefix}-breadCrumb-link`}>
              {my_solution_detail.plugin_text}
            </Link>
            &nbsp;/&nbsp;
            <Link to={`${publicPath}/my_solution`} className={`${prefix}-breadCrumb-link`}>
              {my_solution_detail.my_solution_text}
            </Link>
            &nbsp;/&nbsp;
            <Dropdown menu={{ items: dropdownList, style: { maxHeight: "70vh" } }}>
              <Space style={{ color: "#1A1A1A" }}>
                {solutionDetail?.versions[0]?.title || dropdownCur || "--"}
                <DownOutlined />
              </Space>
            </Dropdown>
          </div>
          {current === "versionmanage" ? (
            <div className={`${prefix}-top-right`}>
              <Button type="link" disabled={isAddVersion} onClick={upgrade}>
                {add + my_solution_detail.version}
              </Button>
              <Dropdown
                menu={{
                  items: dropdownItems,
                  selectable: true,
                  selectedKeys: [dropdownSelect],
                  onClick: dropdownOnClick,
                }}
                overlayClassName={`${prefix}-dropdown-overlay`}
              >
                <span className={`${prefix}-dropdown`}>
                  <Space>
                    {my_solution_detail.version}
                    <DownOutlined />
                  </Space>
                </span>
              </Dropdown>
            </div>
          ) : (
            <span></span>
          )}
        </div>

        <Outlet />
      </ConfigProvider>
    </div>
  );
}

export default MySolutionDetail;
